<template>
  <v-card>
    <v-card-title class="headline" style="background-color: #0d3c61; color: #fff;">
      CADASTRO COM RESTRIÇÃO
    </v-card-title>
    <v-card-text>
      <v-layout align-center>
        <v-icon color="orange darken-2" large class="mr-3">warning</v-icon>
        <div>
          <p style="margin-bottom: 12px;">
            A validação do CPF/CNPJ retornou uma ocorrência que impede a continuidade deste cadastro.
          </p>
          <p style="margin-bottom: 4px; font-weight: 500;">Motivo:</p>
          <p style="font-weight: 700;">{{ motivo }}</p>
        </div>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat style="background-color: #0d3c61; color: #fff;" @click="fechar()">ENTENDI</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ModalBloqueioCnpjCpf",
  props: {
    motivo: {
      type: String,
      default: ""
    }
  },
  methods: {
    fechar() {
      this.$emit("fechar");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalBloqueioCnpjCpf.vue